export default __webpack_public_path__ + "static/media/434.e5a2f5fb.png";